/**
 * Console authentication tools for debugging
 */
import { authDebugger } from "./authDebugger";
import { authStateManager } from "./authStateManager";

// Make debugging tools available globally
if (typeof window !== "undefined") {
  (window as any).authDebugger = authDebugger;
  (window as any).authStateManager = authStateManager;

  // Add some convenience functions
  (window as any).authDebug = () => {
    console.log("=== AUTH DEBUG TOOLS ===");
    console.log("Available commands:");
    console.log(
      "- await authDebugger.logDebugInfo() - Show detailed auth state"
    );
    console.log("- authStateManager.getAuthState() - Get current auth state");
    console.log("- authStateManager.validateAuthState() - Validate auth state");
    console.log(
      "- await authDebugger.autoFixIssues() - Try to fix auth issues"
    );
    console.log("- authStateManager.clearAuthState() - Clear all auth data");
    console.log("=========================");
  };

  // Only show debug tools in development
  if (process.env.NODE_ENV === "development") {
    console.log("🔧 Auth debugging tools loaded!");
    console.log("Type 'authDebug()' for available commands");

    // Show initial auth state
    setTimeout(async () => {
      console.log("📊 Initial auth state:");
      await authDebugger.logDebugInfo();
    }, 1000);
  }
}
